import React from 'react';
// eslint-disable-next-line no-restricted-imports
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

export type Direction = 'left' | 'right';

export interface NavigationDrawerProps {
    children: React.ReactNode;
    direction: Direction;
    toggleDrawer: any;
    isOpen: boolean;
}

export class NavigationDrawer extends React.Component<NavigationDrawerProps> {
    render() {
        return (
            <SwipeableDrawer
                disableSwipeToOpen={true}
                disableDiscovery={true}
                anchor={this.props.direction}
                open={this.props.isOpen}
                onClose={this.props.toggleDrawer(this.props.direction, false)}
                onOpen={this.props.toggleDrawer(this.props.direction, true)}
                disableBackdropTransition={true}
            >
                <div
                    tabIndex={0}
                    role="button"
                    onClick={this.props.toggleDrawer(this.props.direction, false)}
                    onKeyDown={this.props.toggleDrawer(this.props.direction, false)}
                >
                    <div style={{ width: 260, position: 'relative' }}>{this.props.children}</div>
                </div>
            </SwipeableDrawer>
        );
    }
}
